import { DatePicker } from "@material-ui/pickers";
import React from "react";
import {
  BooleanInput,
  FormDataConsumer,
  NumberInput,
  Record,
  required,
  SimpleForm,
  TextInput,
} from "react-admin";
import { useParams } from "react-router-dom";
import { CustomResourceRouteParams } from "../../../../common/types";
import { GenericDateOrTimePicker } from "../../../common/form/GenericDateOrTimePicker";
import { NextMaintenanceForm } from "./NextMaintenanceForm";

interface Props {
  record?: Record;
}

export const VehicleMaintenanceForm = (props: Props) => {
  const params = useParams<CustomResourceRouteParams>();

  return (
    <SimpleForm {...props} variant="outlined" className="form-create-edit">
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="date"
        label="resources.assets-vehicle-maintenance.labels.date"
        validate={required()}
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
      />
      <BooleanInput
        source="isRegularMaintenance"
        label="resources.assets-vehicle-maintenance.labels.isRegularMaintenance"
      />
      <NumberInput
        source="vehicleOdometer"
        label="resources.assets-maintenance.labels.vehicleOdometer"
        validate={required()}
      />
      <TextInput
        multiline
        source="notes"
        label="resources.assets-vehicle-maintenance.labels.notes"
      />
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData["isRegularMaintenance"]) {
            return null;
          }

          return (
            <NextMaintenanceForm {...rest} vehicleId={Number(params["id"])} />
          );
        }}
      </FormDataConsumer>
    </SimpleForm>
  );
};
